// Libraries
import React, {ChangeEvent} from 'react'

// Components
import {
  Columns,
  ComponentSize,
  ComponentStatus,
  FlexBox,
  Form,
  Grid,
  Input,
  InputType,
  Panel,
  FlexDirection,
} from '@influxdata/clockface'
import ProviderPanelContents from '../ProviderRegion/ProviderPanelContents'
import RegionPanelContents from '../ProviderRegion/RegionPanelContents'
import SplashCTA from './SplashCTA'
import SplashSectionHeading from './SplashSectionHeading'
import LegalCheckbox from 'js/components/SignUp/LegalCheckbox'
import {isFlagEnabled} from '../FeatureFlags/FeatureFlag'

interface Props {
  isAgreeingToTerms: boolean
  handleAgreement: () => void
  showReminder: boolean
  handleChangeRegion: (infoBefore: any, infoAfter: any) => void
  buttonStatus: ComponentStatus
  company: string
  companyError: string
  organization: string
  organizationError: string
  firstName: string
  firstNameError: string
  lastName: string
  lastNameError: string
  handleChangeCompany: (e: ChangeEvent<HTMLInputElement>) => void
  handleChangeOrganization: (e: ChangeEvent<HTMLInputElement>) => void
  handleChangeFirstName: (e: ChangeEvent<HTMLInputElement>) => void
  handleChangeLastName: (e: ChangeEvent<HTMLInputElement>) => void
}

const OrganicSplashPageContents = ({
  isAgreeingToTerms,
  handleChangeRegion,
  handleAgreement,
  showReminder,
  buttonStatus,
  company,
  companyError,
  organization,
  organizationError,
  firstName,
  firstNameError,
  lastName,
  lastNameError,
  handleChangeCompany,
  handleChangeOrganization,
  handleChangeFirstName,
  handleChangeLastName,
}: Props): JSX.Element => {
  return (
    <>
      <Grid.Row>
        <Grid.Column
          widthSM={Columns.Ten}
          offsetSM={Columns.One}
          widthMD={Columns.Ten}
          offsetMD={Columns.One}
        >
          <Panel style={{padding: '3em'}}>
            <Panel.Body size={ComponentSize.Medium}>
              {isFlagEnabled('auth0UniversalLoginEnabled', 'true') && (
                <>
                  <SplashSectionHeading title="Personal Information" />
                  <FlexBox
                    direction={FlexDirection.Row}
                    margin={ComponentSize.Large}
                  >
                    <Form.Element
                      label="First Name"
                      errorMessage={firstNameError}
                    >
                      <Input
                        name="firstName"
                        testID="firstName--input"
                        value={firstName}
                        type={InputType.Text}
                        size={ComponentSize.Medium}
                        status={
                          firstNameError
                            ? ComponentStatus.Error
                            : ComponentStatus.Default
                        }
                        onChange={handleChangeFirstName}
                      />
                    </Form.Element>
                    <Form.Element
                      label="Last Name"
                      errorMessage={lastNameError}
                      style={{whiteSpace: 'nowrap', marginTop: '0px'}}
                    >
                      <Input
                        name="lastName"
                        testID="lastName--input"
                        value={lastName}
                        type={InputType.Text}
                        size={ComponentSize.Medium}
                        status={
                          lastNameError
                            ? ComponentStatus.Error
                            : ComponentStatus.Default
                        }
                        onChange={handleChangeLastName}
                      />
                    </Form.Element>
                  </FlexBox>
                </>
              )}

              <SplashSectionHeading title="Workspace Details" />
              <FlexBox
                direction={FlexDirection.Row}
                margin={ComponentSize.Large}
              >
                <Form.Element
                  label="Account"
                  helpText="Your company name"
                  errorMessage={companyError}
                >
                  <Input
                    name="company"
                    testID="company--input"
                    value={company}
                    type={InputType.Text}
                    size={ComponentSize.Medium}
                    status={
                      companyError
                        ? ComponentStatus.Error
                        : ComponentStatus.Default
                    }
                    onChange={handleChangeCompany}
                  />
                </Form.Element>
                <Form.Element
                  label="Organization"
                  helpText="Your first organization or project in your account"
                  errorMessage={organizationError}
                >
                  <Input
                    name="orgName"
                    testID="orgName--input"
                    placeholder="Dev Team, US Eastern Region, Staging"
                    value={organization}
                    type={InputType.Text}
                    size={ComponentSize.Medium}
                    status={
                      organizationError
                        ? ComponentStatus.Error
                        : ComponentStatus.Default
                    }
                    onChange={handleChangeOrganization}
                  />
                </Form.Element>
              </FlexBox>

              <SplashSectionHeading
                title="Storage Provider"
                subtitle="This is where we will store your time series data."
              />
              <ProviderPanelContents />
              <RegionPanelContents
                onChange={handleChangeRegion}
                hideLabel={true}
              />

              <LegalCheckbox
                isError={showReminder}
                isAgreeing={isAgreeingToTerms}
                onToggleAgree={handleAgreement}
              />
            </Panel.Body>
          </Panel>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <SplashCTA nextStep="Choose a plan" status={buttonStatus} />
      </Grid.Row>
    </>
  )
}

export default OrganicSplashPageContents
